var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total"},[_c('h3',[_vm._v(_vm._s(_vm.translation.overall_rating))]),_c('p',[_vm._v("("+_vm._s(_vm.rating)+" "+_vm._s(_vm.translation.reviews)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }